import CONTRATISTAS from '@/graphql/querys/administracion/catalogos/contratistas/contratistas.gql';
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratos.gql';
import PAGOS_SOLICITUDES from '@/graphql/querys/administracion/pagos/pagosSolicitudes.gql';
import AGREGAR_SOLICITUD_PAGO from '@/graphql/mutations/administracion/pagos/solicitudes/agregarPagosSolicitud.gql';
import REMOVER_SOLICITUD_PAGO from '@/graphql/mutations/administracion/pagos/solicitudes/removerPagosSolicitud.gql';
import REMOVER_SOLICITUD_PAGO_DETALLE from '@/graphql/mutations/administracion/pagos/solicitudes/removerPagosSolicitudesDetalle.gql';
import AGREGAR_PAGO from '@/graphql/mutations/administracion/pagos/agregarPagos.gql';
import REMOVER_PAGO from '@/graphql/mutations/administracion/pagos/removerPago.gql';
import REMOVER_PAGO_DETALLE from '@/graphql/mutations/administracion/pagos/removerPagoDetalle.gql';
import PAGOS from '@/graphql/querys/administracion/pagos/pagos.gql';

export default {
  apollo: {
    contratistas: {
      query: CONTRATISTAS,
    },
    contratos: {
      query: CONTRATOS,
    },
    pagosSolicitudes: {
      query: PAGOS_SOLICITUDES,
    },
    pagos: {
      query: PAGOS,
    },
  },
  methods: {
    async mixGuardarSolicitudPago() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      // Enviar la informacion
      await this.$apollo
        .mutate({
          mutation: AGREGAR_SOLICITUD_PAGO,
          variables: {
            solicitud: this.solicitud,
          },
          update: (store, { data: { agregarPagosSolicitud } }) => {
            const query = {
              query: PAGOS_SOLICITUDES,
            };

            const { pagosSolicitudes } = store.readQuery(query);
            pagosSolicitudes.push(agregarPagosSolicitud);

            store.writeQuery({
              ...query,
              data: {
                pagosSolicitudes,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixGuardarPago() {
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: AGREGAR_PAGO,
          variables: {
            pago: this.pago,
          },
          update: (store, { data: { agregarPagos } }) => {
            const data = store.readQuery({ query: PAGOS });
            data.pagos.push(agregarPagos);
            store.writeQuery({ query: PAGOS, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Solicitud de pago
    async mixEliminarSolicitudPago() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_SOLICITUD_PAGO,
          variables: {
            id: this.solicitudPagoEliminar.id,
          },
          update: (store) => {
            const query = {
              query: PAGOS_SOLICITUDES,
            };
            const data = store.readQuery(query);
            const { pagosSolicitudes } = data;
            const index = pagosSolicitudes.findIndex(
              (pagoSolicitud) => pagoSolicitud.id === this.solicitudPagoEliminar.id,
            );
            if (index !== -1) {
              pagosSolicitudes.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Detalle de solicitud de pago
    async mixEliminarSolicitudPagoDetalle() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_SOLICITUD_PAGO_DETALLE,
          variables: {
            id: this.solicitudPagoEliminar.id,
          },
          update: (store) => {
            const query = {
              query: PAGOS_SOLICITUDES,
            };
            const data = store.readQuery(query);
            const { pagosSolicitudes } = data;
            // Busco la solicitud a la que pertenece el detalle
            const solicitudPadre = pagosSolicitudes.find(
              (solicitud) => solicitud.id === this.solicitudPagoEliminar.idPagosSolicitud,
            );
            // obtengo los detalles de la solicitud
            const { detalles } = solicitudPadre;
            // obtengo el index del detalle que se eliminará
            const indexDetalle = detalles.findIndex(
              (detalle) => detalle.id === this.solicitudPagoEliminar.id,
            );
            if (indexDetalle !== -1) {
              // se elimina el detalle
              detalles.splice(indexDetalle, 1);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Pago
    async mixEliminarPago() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_PAGO,
          variables: {
            id: this.pagoEliminar.id,
          },
          update: (store) => {
            const query = {
              query: PAGOS,
            };
            const data = store.readQuery(query);
            const { pagos } = data;
            const index = pagos.findIndex((pago) => pago.id === this.pagoEliminar.id);
            if (index !== -1) {
              pagos.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Detalle de pago
    async mixEliminarPagoDetalle() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_PAGO_DETALLE,
          variables: {
            id: this.pagoEliminar.id,
          },
          update: (store) => {
            const query = {
              query: PAGOS,
            };
            const data = store.readQuery(query);
            const { pagos } = data;
            // Busco el pago al que pertenece el detalle
            const pagoPadre = pagos.find((pago) => pago.id === this.pagoEliminar.idPago);
            // obtengo los detalles del pago
            const { detalles } = pagoPadre;
            // obtengo el index del detalle que se eliminará
            const indexDetalle = detalles.findIndex(
              (detalle) => detalle.id === this.pagoEliminar.id,
            );
            if (indexDetalle !== -1) {
              // se elimina el detalle
              detalles.splice(indexDetalle, 1);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    mixPagosSolicitudes() {
      if (!this.pagosSolicitudes) return [];
      return this.pagosSolicitudes;
    },
    mixGetContratistas() {
      if (!this.contratistas) return [];
      return this.contratistas.sort((a, b) => a.nombreRazonSocial.localeCompare(b.nombreRazonSocial));
    },
    mixGetContratosPorContratista() {
      if (!this.contratos) return [];
      return this.contratos.filter(({ idContratista }) => idContratista === this.idContratista);
    },
    mixGetAnticipos() {
      if (!this.contratos) return [];
      return this.mixGetContratosPorContratista
        .filter(({ id }) => id === this.solicitud.idContrato)
        .filter(({ anticipos }) => anticipos.length > 0)
        .map(({ anticipos }) => anticipos)
        .flat()
        .map(({ id, fecha, total }) => ({
          id,
          fecha,
          total,
          color: 'green darken-1',
          tipo: 'Anticipo',
        }))
        .filter(({ id }) => !this.mixReferenciasRegistradas.includes(id))
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        .map((anticipo) => ({
          ...anticipo,
          numero: '',
        }));
    },
    mixGetEstimaciones() {
      if (!this.contratos) return [];
      return this.mixGetContratosPorContratista
        .filter(({ id }) => id === this.solicitud.idContrato)
        .filter(({ estimaciones }) => estimaciones.length > 0)
        .map(({ estimaciones }) => estimaciones)
        .flat()
        .map(({
          id, numero, fechaDel, totalFactura,
        }) => ({
          id,
          fecha: fechaDel,
          total: totalFactura,
          color: 'light-blue darken-1',
          tipo: 'Estimación',
          numero,
        }))
        .filter(({ id }) => !this.mixReferenciasRegistradas.includes(id))
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
    },
    mixEscalatorias() {
      if (!this.contratos) return [];
      return this.mixGetContratosPorContratista
        .filter(({ id }) => id === this.solicitud.idContrato)
        .filter(({ escalatorias }) => escalatorias.length > 0)
        .map(({ escalatorias }) => escalatorias)
        .flat()
        .map(({
          id, numero, fechaDel, total,
        }) => ({
          id,
          fecha: fechaDel,
          total,
          color: 'brown darken-1',
          tipo: 'Escalatoria',
          numero,
        }))
        .filter(({ id }) => !this.mixReferenciasRegistradas.includes(id))
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
    },
    mixGastos() {
      if (!this.contratos) return [];
      return this.mixGetContratosPorContratista
        .filter(({ id }) => id === this.solicitud.idContrato)
        .filter(({ gastos }) => gastos.length > 0)
        .map(({ gastos }) => gastos)
        .flat()
        .map(({
          id, numero, fechaDel, total,
        }) => ({
          id,
          fecha: fechaDel,
          total,
          color: 'pink darken-1',
          tipo: 'Gasto',
          numero,
        }))
        .filter(({ id }) => !this.mixReferenciasRegistradas.includes(id))
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
    },
    mixReferenciasRegistradas() {
      return this.mixPagosSolicitudes
        .map(({ detalles }) => detalles.map(({ idReferencia }) => idReferencia).flat())
        .flat();
    },
    mixReferenciasDePagoDisponibles() {
      return [
        { header: 'Anticipos', cantidad: this.mixGetAnticipos.length },
        ...this.mixGetAnticipos,
        { header: 'Estimaciones', cantidad: this.mixGetEstimaciones.length },
        ...this.mixGetEstimaciones,
        { header: 'Escalatorias', cantidad: this.mixEscalatorias.length },
        ...this.mixEscalatorias,
        { header: 'Gastos', cantidad: this.mixGastos.length },
        ...this.mixGastos,
      ];
    },
    mixGetContratosSolicitudes() {
      return this.$removerDumplicadosArrayObj(
        this.mixPagosSolicitudes.map(({ contrato }) => contrato),
        'id',
      );
    },
    mixGetContratitasSolicitudes() {
      return this.mixGetContratosSolicitudes.map(({ contratista }) => contratista);
    },
    mixSolicitudesPagadas() {
      if (!this.pagos) return [];
      return this.pagos
        .map((pago) => pago.detalles.map(({ idPagosSolicitudesDetalles }) => idPagosSolicitudesDetalles))
        .flat();
    },
  },
};
